import MenuIconTooltip from "./MenuIconTooltip";
import "./RadiantBlasonDisplay.css";

export default function RadiantBlasonDisplay({
  imageSrc = null,
  gradeName = "",
  showLabel = true,
  emptyLabel = "",
  locked = false,
  className = "",
  requirementTooltip = "",
}) {
  if (!imageSrc) {
    return (
      <div
        className={[
        "radiant-blason-display",
        "radiant-blason-display--empty",
        locked ? "radiant-blason-display--locked" : "",
        !showLabel ? "radiant-blason-display--no-label" : "",
          className,
        ]
          .filter(Boolean)
          .join(" ")}
      >
        {emptyLabel ? (
          <span className="radiant-blason-display__empty-label">{emptyLabel}</span>
        ) : null}
      </div>
    );
  }

  return (
    <div
      className={[
        "radiant-blason-display",
        locked ? "radiant-blason-display--locked" : "",
        !showLabel ? "radiant-blason-display--no-label" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="radiant-blason-display__image-wrap">
        <img
          src={imageSrc}
          alt=""
          aria-hidden="true"
          className="radiant-blason-display__image"
          draggable={false}
        />
      </div>
      {showLabel && gradeName ? (
        requirementTooltip ? (
          <MenuIconTooltip
            tooltip={requirementTooltip}
            placement="above"
            portal
            className="radiant-blason-display__label radiant-blason-display__label--tip"
          >
            <span className="radiant-blason-display__label-text">{gradeName}</span>
          </MenuIconTooltip>
        ) : (
          <p className="radiant-blason-display__label">{gradeName}</p>
        )
      ) : null}
    </div>
  );
}
